import type { ChannelItem } from '@fourthwall/module-create-site'
import { getSlugFromString } from '@fourthwall/utils/dist/string'

import type { FormValues, Payload } from '../CreateNewSiteModal.types'

export const isSearchedChannelType = (
  searchedChannel: FormValues['searchedChannel'],
): searchedChannel is ChannelItem => {
  return (searchedChannel as ChannelItem).channelUrl !== undefined
}

const getPreonboarding = (values: FormValues): Payload['preonboarding'] => {
  if (values.siteForSomeoneElse) {
    const channelData = isSearchedChannelType(values.searchedChannel)
      ? values.searchedChannel
      : { channelUrl: values.channelUrl, name: undefined, handle: undefined }
    const { channelUrl, name: channelName, handle: channelHandle } = channelData

    return {
      creatorName: values.creatorName,
      creatorLocation: values.location,
      platform: values.platform!,
      channelUrl,
      channelName,
      channelHandle,
    }
  }

  return undefined
}

export const getPayloadFromFormValues = (values: FormValues, timezone: string): Payload => ({
  siteName: values.siteName,
  slug: getSlugFromString(values.siteName),
  preonboarding: getPreonboarding(values),
  timezone,
})
